import axios from "axios";

class AxiosClient {
  createAxios(baseURL) {
    // axios
    const apiClient = axios.create({
      baseURL,
      withCredentials: false,
      timeout: 300000, // 5 minutos
      headers: {
        "Content-Type": "application/json",
      },
    });

    apiClient.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    apiClient.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          window.dispatchEvent(new CustomEvent("unauthorized"));
        }
        return Promise.reject(error);
      },
    );

    return apiClient;
  }
}

let axiosInstance = null;

export function getAxiosInstance() {
  if (!axiosInstance) {
    throw new Error(
      "Axios instance not initialized. Call initializeAxios() first.",
    );
  }
  return axiosInstance;
}

export function initializeAxios(baseURL) {
  const axiosClient = new AxiosClient();
  axiosInstance = axiosClient.createAxios(baseURL);
  return axiosInstance;
}

export default AxiosClient;
